import React, {FC, Suspense} from 'react';
import {LazyReportBuilder} from "@containers/reports/reportBuilder/ReportBuilder.lazy";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from '@view/layout/pageLayout/PageLayout';
import {BREADCRUMBS_REPORT_BUILDER} from "@pages/reports/reportBuilderPage/constants/breadcrumbs";
import {Box} from '@mui/material';
import {sx} from './sx'

interface IProps {
    showBreadcrumbs?: boolean
}

const ReportBuilderPage: FC<IProps> = ({showBreadcrumbs}) => {
    return (
        <PageLayout breadcrumbs={showBreadcrumbs && BREADCRUMBS_REPORT_BUILDER}>
            <Box sx={sx.root}>
                <Suspense
                    fallback={<SpinnerCustom/>}
                >
                    <LazyReportBuilder/>
                </Suspense>
            </Box>
        </PageLayout>
    );
};

export default ReportBuilderPage;